import { ContractPage } from "apps/batchOnboarding/contract/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(ContractPage, "BulkContractPage");
